import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
            '-centered': _ctx.getState().isCentered,
            '-has-no-border': _ctx.getState().hasNoBorder,
            '-has-no-padding': _ctx.getState().hasNoPadding,
            '-padded-content': _ctx.getState().hasPaddedContent,
        }, "m-panel__row"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}